var _circle, _path, _path2, _line, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasketball(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    xmlSpace: "preserve",
    stroke: "currentColor",
    strokeWidth: 25,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 400
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.7,642.3c0,0-36.6-125.8,91.5-244.1S640.4,210.4,511.4,112"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M381.7,890.3c0,0,125.8,36.6,244.1-91.5S813.6,383.6,912,512.6"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 229.2,
    y1: 794.8,
    x2: 794.8,
    y2: 229.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M254.6,205.8c0,0,230.9-121.6,458,105.6s105.6,458,105.6,458"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketball);
export default __webpack_public_path__ + "static/media/Basketball.20777c523efc69b31fba2b15ba9ffcab.svg";
export { ForwardRef as ReactComponent };